import { render, staticRenderFns } from "./product_allergens.vue?vue&type=template&id=0388b342&scoped=true&"
import script from "./product_allergens.vue?vue&type=script&lang=js&"
export * from "./product_allergens.vue?vue&type=script&lang=js&"
import style0 from "./product_allergens.vue?vue&type=style&index=0&id=0388b342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388b342",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0388b342')) {
      api.createRecord('0388b342', component.options)
    } else {
      api.reload('0388b342', component.options)
    }
    module.hot.accept("./product_allergens.vue?vue&type=template&id=0388b342&scoped=true&", function () {
      api.rerender('0388b342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_allergens.vue"
export default component.exports